<div class="flex flex-col gap-y-2 grow basis-full justify-self-stretch h-full justify-items-stretch app-full-height">
  <div class="flex flex-col md:flex-row justify-between items-center m-4 flex-grow-0">
    <h1 class="flex-grow">Dashboard</h1>
    <a mat-flat-button [routerLink]="['combined-calendar']" data-cy="combined-calendar-view">Calendar View</a>
    <button mat-flat-button [testId]="'new-transaction-button'" color="primary" (click)="newHireContract()"
      id="new-hire-contract">
      New Transaction
    </button>
  </div>
  <div *ngIf="!_selectedView; else view" class="flex flex-grow-0 flex-col gap-y-6 mx-4">
    <h2>Overview</h2>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 grid-flow-row-dense"
      *ngIf="statsProcessed$ | async as statsProcessed">
      @for (tile of statsProcessed; track tile.title) {
      @if (tile.type === 'builtin') {
      @if (tile.link === 'my-jobs') {
      <app-my-jobs></app-my-jobs>
      } @else {
      <mat-card appearance="outlined" (click)="showView(tile.link)">
        <mat-card-content>
          <h2 class="text-slate-500 w-full">
            {{ tile.title }}
          </h2>
          <h1>{{ tile.bigFigureValue }}</h1>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-y-4 group">
            <div class="flex flex-row justify-start items-center gap-x-2" *ngFor="let stat of tile.stats">
              <p *ngIf="!stat.link && !stat.useCurrencyPipe">
                {{ stat.displayName }}: {{ stat.value }}
              </p>
              <p *ngIf="!stat.link && stat.useCurrencyPipe">
                {{ stat.displayName }}:
                {{ stat.value | hlCurrency | async }}
              </p>
              <p *ngIf="stat.link && stat.useCurrencyPipe">
                {{ stat.displayName }}:
                <a (click)="
                          showFilteredView(stat.link[0], stat.link[1], $event)
                        ">{{ stat.value | hlCurrency | async }}</a>
              </p>
              <p *ngIf="stat.link && !stat.useCurrencyPipe">
                {{ stat.displayName }}:
                <a (click)="
                          showFilteredView(stat.link[0], stat.link[1], $event)
                        ">{{ stat.value }}</a>
              </p>
              <button (click)="
                        showFilteredView(stat.link[0], stat.link[1], $event)
                      " class="lg:invisible group-hover:visible" mat-button>
                View
              </button>
            </div>
          </div>
        </mat-card-content>
        @if (tile.title === 'Transport Jobs') {
        <mat-card-actions>
          <button mat-flat-button (click)="openDeliveryEstimator($event)">
            Delivery Price Tool
          </button>
        </mat-card-actions>
        }
      </mat-card>
      }
      } @else if (tile.type === 'custom') {
      <!-- <app-custom-dashboard-tile [tile]="tile"></app-custom-dashboard-tile> -->
      }
      }
    </div>
  </div>
  <ng-template #view>
    <div [ngSwitch]="_selectedView" class="mx-4 flex flex-grow basis-full flex-col justify-items-stretch">
      <div *ngSwitchCase="'active'" class="flex flex-grow flex-col gay-y-4 basis-full pb-12">
        <div class="flex-row flex-grow-0 py-4 flex justify-between items-center gap-x-4 flex-grow-0">
          <div class="flex flex-col md:flex-row gap-x-4 flex-shrink-0 flex-grow-0 justify-start items-center">
            <h2>Active Contracts</h2>
            <button mat-stroked-button color="primary" (click)="showView(null)">
              Back to Overview
            </button>
          </div>
          <button mat-icon-button color="primary" (click)="toggleFilter()" data-cy="filter-active">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="filter"></ng-container>
        <ag-grid-angular #agGrid [ngStyle]="{
            'height.%': 100,
            'width.%': '100',
            'min-height': '400px'
          }" class="ag-theme-alpine" [rowData]="filteredDockets$ | async" [columnDefs]="columns"
          [gridOptions]="gridOptions"></ag-grid-angular>
      </div>

      <div *ngSwitchCase="'pending'" class="flex flex-grow flex-col gay-y-4 basis-full pb-12">
        <div class="flex-row flex-grow-0 py-4 flex justify-between items-center gap-x-4 flex-grow-0">
          <div class="flex flex-row gap-x-4 flex-shrink-0 flex-grow-0 justify-start items-center">
            @if ((pendingFilter$ | async) === 'overpaid') {
            <h2>Overpaid Hires</h2>
            } @else {
            <h2>Pending Payment</h2>
            }
            <button mat-stroked-button color="primary" (click)="showView(null)">
              Back to Overview
            </button>
          </div>
        </div>
        <app-pending-payment-list [docketType]="pendingFilter$ | async"></app-pending-payment-list>
      </div>

      <div *ngSwitchCase="'bookings'" class="flex flex-grow flex-col gay-y-4 basis-full pb-12">
        <div class="flex-row flex-grow-0 py-4 flex justify-between items-center gap-x-4 flex-grow-0">
          <div class="flex flex-row gap-x-4 flex-shrink-0 flex-grow-0 justify-start items-center">
            <h2>Bookings</h2>
            <button mat-stroked-button color="primary" (click)="showView(null)">
              Back to Overview
            </button>
          </div>
          <button mat-icon-button color="primary" (click)="toggleFilter()" data-cy="filter-bookings">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="filter"></ng-container>
        <booking-list [bookings]="filteredBookings$ | async" [height]="height" class="h-5/6"></booking-list>
      </div>

      <div *ngSwitchCase="'deliveries'" class="flex flex-grow flex-col gay-y-4 basis-full pb-12">
        <div class="flex flex-row justify-between items-center">
          <div class="flex flex-row gap-x-4 justify-start items-center">
            <h2>Transport Jobs</h2>
            <button mat-stroked-button color="primary" (click)="showView(null)">
              Back to Overview
            </button>
          </div>
          <button mat-icon-button color="primary" (click)="toggleFilter()" data-cy="filter-deliveries">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <ng-container *ngTemplateOutlet="filter"></ng-container>
        <delivery-list [deliveries]="filteredDeliveries$ | async" [height]="height"></delivery-list>
      </div>
    </div>

    <ng-template #filter>
      <div
        class="flex flex-grow-0 flex-col md:flex-row md:gap-x-4 gap-y-4 md:gap-y-0 md:justify-start md:items-center my-4 dashboard-filter"
        *ngIf="showFilter" [formGroup]="filterForm">
        <mat-form-field class="md:flex-grow md:flex-shrink md:basis-1/4">
          <mat-label>Filter customers</mat-label>
          <input matInput autofocus formControlName="customer" id="filter-tables" placeholder="Filter customers" />
        </mat-form-field>
        <mat-form-field class="md:flex-grow md:flex-shrink md:basis-1/4">
          <mat-label>Filter hire location</mat-label>
          <mat-select placeholder="Filter hire location" name="Location" id="location-select"
            formControlName="location">
            <mat-option *ngFor="let location of locations" [value]="location.id">{{ location.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="md:flex-grow md:flex-shrink md:basis-1/4">
          <mat-label>Filter Hirer</mat-label>
          <mat-select placeholder="Filter hirer" name="user" id="user-select" formControlName="user">
            <mat-option *ngFor="let user of users" [value]="user.id">{{ user.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-button (click)="clearFilters()" id="clear-filters">
          Clear Filters
        </button>
      </div>
      <div *ngIf="easyFilterSelected" class="flex md:flex-row gap-x-4">
        <p>
          Only Showing: <strong>{{ easyFilterSelected }}</strong>
        </p>
        <button (click)="removeEasyFilter()" mat-button-flat>Show All</button>
      </div>
    </ng-template>
  </ng-template>
</div>